var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44975 1.9274L7.57105 4.04869L2.62132 8.99844H0.5V6.87714L5.44975 1.9274ZM6.15685 1.22029L7.2175 0.159629C7.4128 -0.0356314 7.72935 -0.0356314 7.9246 0.159629L9.33885 1.57384C9.5341 1.7691 9.5341 2.08569 9.33885 2.28095L8.27815 3.34161L6.15685 1.22029Z",
    fill: "#207DF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.a4f5001a3564239ae3bf0a314eb4ce6a.svg";
export { ForwardRef as ReactComponent };